/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import StepperNotes from "../Widgets/StepperNotes";
import { useParams } from "react-router-dom";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { AxiosResponse } from "axios";
import { MessagesPanelProps } from "../../Utils/Types";
import { NoteModel } from "../../Utils/Models";

export default function MessagesPanel(props: MessagesPanelProps) {
  const { triggerReload } = props;
  const { id } = useParams();
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    getNotes();
  }, [triggerReload]);

  const getNotes = () => {
    getData(`${endpoints.orderAudits}/${id}`).then((res: AxiosResponse) => {
      if (!res?.data) return;
      setNotes(res.data);
    });
  };

  const updateNotes = (notes: any) => {
    setNotes(notes);
  };
  /**
   *
   */
  return (
    <div>
      <StepperNotes notes={notes} updateNotes={(notes) => updateNotes(notes)} />
    </div>
  );
}
